
//企业官网前台相关API接口模块
import request from "@/utils/server.js";
// 企业官网查询轮播图，经典案例，双渠道服务列表 10-轮播图，20-经典案例，30-双渠道服务
export function getHomeBannerAPI(params) {
  return request({
    url: "/wx/company/ScdType/list",
    method: "get",
    params,
  });
}
